var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.54 6.43333L13.3567 0.213333C13.2233 0.0766667 13.04 0 12.85 0H0.97C0.573333 0 0.25 0.323333 0.25 0.723333V23.2767C0.25 23.6767 0.573333 24 0.97 24H19.03C19.4267 24 19.75 23.6767 19.75 23.2767V6.94667C19.75 6.75333 19.6733 6.57 19.54 6.43667V6.43333ZM13.5667 2.47L17.2933 6.22H13.5667V2.47ZM1.68667 22.5533V1.44667H12.1267V7.67H18.31V22.5533H1.68667ZM9.31333 10.4133V17.7533L7.33 15.77C7.19333 15.6333 7.02 15.57 6.84333 15.57C6.66667 15.57 6.49 15.6367 6.35667 15.77C6.08667 16.04 6.08667 16.4767 6.35667 16.7433L10.0033 20.39L13.65 16.7433C13.92 16.4733 13.92 16.0367 13.65 15.77C13.38 15.5033 12.9433 15.5 12.6767 15.77L10.6933 17.7533V10.4133H9.31667H9.31333Z",
    fill: "#415385"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadFile);
export default __webpack_public_path__ + "static/media/download-file.04fde884bd80f1d332c89a6c5d4d672c.svg";
export { ForwardRef as ReactComponent };